module.exports = __webpack_public_path__ + "static/media/close.c8f9deaa.svg";